var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"panels",staticClass:"tab-panels"},[_c('div',{ref:"panelsGroup",staticClass:"tab-panels-group"},[_vm._t("default",_vm._l((_vm.data),function(item){return _c('tab-panel',{key:item.label,attrs:{"label":item.label}},[_vm._v("\n        "+_vm._s(item.label)+"\n      ")])}))],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0e633281","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/tab-panels.vue
// module id = null
// module chunks = 